module.exports = __webpack_public_path__ + "static/meta-image-be85fe7912c57f893f2ff341f4e03e02.png";